import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DagrunsComponent } from './dagruns/dagruns.component';
import { WorkflowhttpService } from "./services/workflowhttp.service";
import { TranslateModule} from "@ngx-translate/core";
import {
    ModalModule,
    ButtonsModule,
    BsDatepickerModule,
    BsDropdownModule,
    BsDropdownConfig,
    DatepickerModule,
    PopoverModule, PopoverConfig
} from "ngx-bootstrap";
import { DiagramHistoryComponent } from './diagram-history/diagram-history.component';
import { AddBlockPanelComponent } from './add-block-panel/add-block-panel.component';
import { DelayBlockComponent } from './add-block-panel/delay-block/delay-block.component';
import { ConditionalBlockComponent } from './add-block-panel/conditional-block/conditional-block.component';
import { EmailBlockComponent } from './add-block-panel/email-block/email-block.component';
import { ConditionEdgeComponent } from './add-block-panel/condition-edge/condition-edge.component';
import { TriggerRulesPanelComponent } from './trigger-rules-panel/trigger-rules-panel.component';
import { HistoryTimelinePanelComponent } from './history-timeline-panel/history-timeline-panel.component';
import {TriggerDatasetService} from "./services/trigger-dataset.service";
import { SidepanelModule } from "@app/sidepanel/sidepanel.module";
import { MxGraphService } from "@app/workflow-common/services/mx-graph.service";
import { DiagramViewComponent } from './diagram-view/diagram-view.component';
import { OfficetaskBlockComponent } from './add-block-panel/officetask-block/officetask-block.component';
import { AddjobBlockComponent } from './add-block-panel/addjob-block/addjob-block.component';
import { ChatmessageBlockComponent } from './add-block-panel/chatmessage-block/chatmessage-block.component';
import { QuillModule } from "ngx-quill";
import { SmsBlockComponent } from './add-block-panel/sms-block/sms-block.component';
import { UntilconditionBlockComponent } from './add-block-panel/untilcondition-block/untilcondition-block.component';
import { NotificationBlockComponent } from './add-block-panel/notification-block/notification-block.component';
import {WorkflowCommonService} from "@app/workflow-common/services/workflow.common.service";
import {DatePipe, LongDatePipe, PipesModule} from "@app/pipes";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SetcustomfieldvalueBlockComponent } from './add-block-panel/setcustomfieldvalue-block/setcustomfieldvalue-block.component';
import { ScheduledActivityBlockComponent } from './add-block-panel/scheduled-activity-block/scheduled-activity-block.component';
import { DatefilterComponent } from './dagruns/datefilter/datefilter.component';
import { SequenceContainerComponent } from './sequence-container/sequence-container.component';
import { DiagramViewSequenceComponent } from './diagram-view-sequence/diagram-view-sequence.component';
import {MxGraphSequenceService} from "@app/workflow-common/services/mx-graph-sequence";
import { FullScreenHeaderComponent } from './full-screen-header/full-screen-header.component';
import { SendSequenceActionComponent } from './send-sequence-action/send-sequence-action.component';
import { SendSequencePopupComponent } from './send-sequence-popup/send-sequence-popup.component';
import { SequenceAddContactComponent } from './sequence-add-contact/sequence-add-contact.component';
import { SequenceEmailWidgetComponent } from './sequence-email-widget/sequence-email-widget.component';
import { SequenceViewsComponent } from './sequence-views/sequence-views.component';
import { SequenceViewItemComponent } from './sequence-views/sequence-view-item/sequence-view-item.component';
import { SequenceSmsWidgetComponent } from './sequence-sms-widget/sequence-sms-widget.component';
import {
    ConditionalDelayBlockComponent
} from "@app/workflow-common/add-block-panel/conditional-delay-block/conditional-delay-block-component";
import { TriggerActivityComponent } from './trigger-activity/trigger-activity.component';
import { ExitConditionViewComponent } from './exit-condition-view/exit-condition-view.component';
import { ExitCriteriaSidePanelComponent } from './exit-criteria-side-panel/exit-criteria-side-panel.component';
import {DirectivesModule} from "@app/directives";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {CommonFolderStructureModule} from "@app/shared/common-folder-structure/common-folder-structure.module";
import {SmartTableModule} from "@app/smart_table";
import { AuditHistoryComponent } from './workflow-history/audit-history/audit-history.component';
import { WorkflowAuditListComponent } from './workflow-history/workflow-audit-list/workflow-audit-list.component';
import {CsComponentsModule} from "@app/shared/cs-components/cs-components.module";
import { PipelineAutomationComponent } from './pipeline-automation/pipeline-automation.component';
import { ListItemViewComponent } from './pipeline-automation/list-item-view/list-item-view.component';
import {PipelineEventListenerService} from "@app/workflow-common/services/pipeline-event-listener.service";
import { TriggerRuleBuilderComponent } from './pipeline-automation/trigger-rule-builder/trigger-rule-builder.component';
import { AddTaskSidePanelComponent } from './add-task-side-panel/add-task-side-panel.component';
import { EmailBlockWidgetComponent } from './add-task-side-panel/blocks/email-block-widget/email-block-widget.component';
import { SmsBlockWidgetComponent } from './add-task-side-panel/blocks/sms-block-widget/sms-block-widget.component';
import { NotificationBlockWidgetComponent } from './add-task-side-panel/blocks/notification-block-widget/notification-block-widget.component';
import { ChangeStageBlockWidgetComponent } from './add-task-side-panel/blocks/change-stage-block-widget/change-stage-block-widget.component';
import { ScheduledActivityBlockWidgetComponent } from './add-task-side-panel/blocks/scheduled-activity-block-widget/scheduled-activity-block-widget.component';
import { SendProposalBlockWidgetComponent } from './add-task-side-panel/blocks/send-proposal-block-widget/send-proposal-block-widget.component';
import { StartSequenceBlockWidgetComponent } from './add-task-side-panel/blocks/start-sequence-block-widget/start-sequence-block-widget.component';
import { SetSalesPersonBlockWidgetComponent } from './add-task-side-panel/blocks/set-sales-person-block-widget/set-sales-person-block-widget.component';
import { AddJobBlockWidgetComponent } from '@app/workflow-common/add-task-side-panel/blocks/add-job-block-widget/add-job-block-widget.component';
import { SendJobReportBlockWidgetComponent } from './add-task-side-panel/blocks/send-job-report-block-widget/send-job-report-block-widget.component';
import {RouterModule} from "@angular/router";
import { DiagramView2Component } from './diagram-view2/diagram-view2.component';
import { NodeComponent } from './diagram-view2/node/node.component';
import { NodeViewComponent } from './diagram-view2/node-view/node-view.component';
import { CustomAutomationComponent } from './automation-type/custom-automation/custom-automation.component';
import { AutomationSetupComponent } from './automation-type/custom-automation/automation-setup/automation-setup.component';
import {AgGridModule} from "ag-grid-angular";
import { SkippedCommunicationActivityComponent } from '@app/workflow-common/skipped-communication-activity/skipped-communication-activity.component';
import { DiagramService } from "@app/workflow-common/diagram-view2/services/diagram.service";
import { TriggerConditionPanelComponent } from './diagram-view2/panels/trigger-condition-panel/trigger-condition-panel.component';
import { ActionsPanelComponent } from './diagram-view2/panels/actions-panel/actions-panel.component';
import { ConditionalBlockWidgetComponent } from './add-task-side-panel/blocks/conditional-block-widget/conditional-block-widget.component';
import { ProgressSidePanelModule } from "@app/shared/progress-side-panel/progress-side-panel.module";
import { BasicDetailsStepComponent } from './automation-type/custom-automation/automation-setup/basic-details-step/basic-details-step.component';
import { AutomationStepComponent } from './automation-type/custom-automation/automation-setup/automation-step/automation-step.component';
import { WorkflowObservableService } from "@app/workflow-common/services/workflow-observable.service";
import { NodeRootComponent } from './diagram-view2/node-root/node-root.component';
import { ConditionalEdgeComponent } from './add-task-side-panel/blocks/conditional-edge/conditional-edge.component';
import { DelayBlockWidgetComponent } from './add-task-side-panel/blocks/delay-block-widget/delay-block-widget.component';
import { ConditionalDelayBlockWidgetComponent } from './add-task-side-panel/blocks/conditional-delay-block-widget/conditional-delay-block-widget.component';
import { AutomationAuditComponent } from './automation-type/custom-automation/automation-audit/automation-audit.component';
import { InstanceHistoryComponent } from './automation-type/custom-automation/automation-audit/instance-history/instance-history.component';
import { AuditHistory2Component } from './automation-type/custom-automation/automation-audit/audit-history2/audit-history2.component';
import { HistoryTaskStatusModalComponent } from './diagram-view2/panels/history-task-status-modal/history-task-status-modal.component';
import { PutJobHoldWidgetComponent } from './add-task-side-panel/blocks/put-job-hold-widget/put-job-hold-widget.component';
import { SetCustomFieldBlockWidgetComponent } from './add-task-side-panel/blocks/set-custom-field-block-widget/set-custom-field-block-widget.component';

@NgModule({
  declarations: [
      DagrunsComponent,
      DiagramHistoryComponent,
      AddBlockPanelComponent,
      DelayBlockComponent,
      ConditionalBlockComponent,
      EmailBlockComponent,
      ConditionEdgeComponent,
      TriggerRulesPanelComponent,
      HistoryTimelinePanelComponent,
      DiagramViewComponent,
      OfficetaskBlockComponent,
      AddjobBlockComponent,
      ChatmessageBlockComponent,
      SmsBlockComponent,
      UntilconditionBlockComponent,
      NotificationBlockComponent,
      SetcustomfieldvalueBlockComponent,
      ScheduledActivityBlockComponent,
      DatefilterComponent,
      SequenceContainerComponent,
      DiagramViewSequenceComponent,
      FullScreenHeaderComponent,
      SendSequenceActionComponent,
      SendSequencePopupComponent,
      SequenceAddContactComponent,
      SequenceEmailWidgetComponent,
      SequenceViewsComponent,
      SequenceViewItemComponent,
      SequenceSmsWidgetComponent,
      ConditionalDelayBlockComponent,
      TriggerActivityComponent,
      ExitConditionViewComponent,
      ExitCriteriaSidePanelComponent,
      AuditHistoryComponent,
      WorkflowAuditListComponent,
      ExitCriteriaSidePanelComponent,
      PipelineAutomationComponent,
      ListItemViewComponent,
      TriggerRuleBuilderComponent,
      AddTaskSidePanelComponent,
      EmailBlockWidgetComponent,
      SmsBlockWidgetComponent,
      NotificationBlockWidgetComponent,
      ChangeStageBlockWidgetComponent,
      ScheduledActivityBlockWidgetComponent,
      SendProposalBlockWidgetComponent,
      StartSequenceBlockWidgetComponent,
      SetSalesPersonBlockWidgetComponent,
      AddJobBlockWidgetComponent,
      SendJobReportBlockWidgetComponent,
      DiagramView2Component,
      NodeComponent,
      NodeViewComponent,
      CustomAutomationComponent,
      AutomationSetupComponent,
      SkippedCommunicationActivityComponent,

      TriggerConditionPanelComponent,
      ActionsPanelComponent,
      ConditionalBlockWidgetComponent,
      BasicDetailsStepComponent,
      AutomationStepComponent,
      NodeRootComponent,
      ConditionalEdgeComponent,
      DelayBlockWidgetComponent,
      ConditionalDelayBlockWidgetComponent,
      AutomationAuditComponent,
      InstanceHistoryComponent,
      AuditHistory2Component,
      HistoryTaskStatusModalComponent,
      PutJobHoldWidgetComponent,
      SetCustomFieldBlockWidgetComponent,
  ],
    imports: [
        CommonModule,
        //AppCommonModule,
        SidepanelModule,
        ModalModule,
        ButtonsModule,
        BsDatepickerModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        QuillModule,
        InfiniteScrollModule,
        BsDropdownModule,
        DatepickerModule,
        PopoverModule,
        DirectivesModule,
        TooltipModule,
        PipesModule,
        CommonFolderStructureModule,
        SmartTableModule,
        CsComponentsModule,
        RouterModule,
        AgGridModule,
        ProgressSidePanelModule,
    ],
  providers:[
      WorkflowhttpService,
      TriggerDatasetService,
      MxGraphService,
      MxGraphSequenceService,
      WorkflowCommonService,
      DatePipe,
      LongDatePipe,
      PopoverConfig,
      { provide: BsDropdownConfig, useValue: { autoClose: true } },
      PipelineEventListenerService,
      DiagramService,
      WorkflowObservableService,
  ],
    exports: [
        DagrunsComponent,
        DiagramHistoryComponent,
        AddBlockPanelComponent,
        HistoryTimelinePanelComponent,
        TriggerRulesPanelComponent,
        DiagramViewComponent,
        DatepickerModule,
        SequenceContainerComponent,
        DiagramViewSequenceComponent,
        FullScreenHeaderComponent,
        SendSequenceActionComponent,
        SendSequencePopupComponent,
        SequenceAddContactComponent,
        SequenceEmailWidgetComponent,
        SequenceViewsComponent,
        SequenceViewItemComponent,
        TriggerActivityComponent,
        AuditHistoryComponent,
        ExitCriteriaSidePanelComponent,
        PipelineAutomationComponent,
        CustomAutomationComponent,
        SkippedCommunicationActivityComponent,
        DiagramView2Component,
        TriggerConditionPanelComponent,
        CustomAutomationComponent,
    ],
  entryComponents: [
      DagrunsComponent,
      DiagramHistoryComponent,
      AddBlockPanelComponent,
      HistoryTimelinePanelComponent,
      TriggerRulesPanelComponent,
      FullScreenHeaderComponent,
      SendSequencePopupComponent,
      SequenceAddContactComponent,
      SequenceEmailWidgetComponent,
      SequenceSmsWidgetComponent,
      ExitCriteriaSidePanelComponent,
      TriggerRuleBuilderComponent,
      AddTaskSidePanelComponent,
      AutomationSetupComponent,
      TriggerConditionPanelComponent,
      ActionsPanelComponent,
      HistoryTaskStatusModalComponent
  ]
})
export class WorkflowCommonModule { }
